import React, { useEffect, useState } from 'react';
import StructureZoomService from '@Services/StructureZoom';
import AppStorage from '@Services/AppStorage';
import ZoomSlider from './ZoomSlider';

function ZoomSliderContainer(props) {
  const { zoomKey, ...rest } = props;
  const [zoomValue, setZoomValueState] = useState(() => {
    const stored = AppStorage.instance.getFromSessionStorage('zoom');
    return typeof stored === 'number' ? stored : 0;
  });

  useEffect(() => {
    let unsubscribe;
    if (zoomKey) {
      // Subscribe to zoom changes via StructureZoomService
      unsubscribe = StructureZoomService.subscribe(
        zoomKey,
        (val) => {
          setZoomValueState(val);
        },
        true
      );
    }
    return () => {
      if (zoomKey) {
        StructureZoomService.unsubscribe(zoomKey);
      }
      if (typeof unsubscribe === 'function') unsubscribe();
    };
  }, [zoomKey]);

  const setZoomValue = (key, value) => {
    AppStorage.instance.setToSessionStorage('zoom', value);
    StructureZoomService.publish(key, value);
    setZoomValueState(value);
  };

  return <ZoomSlider {...rest} zoomKey={zoomKey} zoomValue={zoomValue} setZoomValue={setZoomValue} />;
}

export default ZoomSliderContainer;
